export default "__VITE_ASSET__CB1jUQTi__"